import React, { useState , useEffect, useCallback} from "react";
import axios from "axios";
import { Box, IconButton,  Container, CircularProgress } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { motion } from "framer-motion";
import "../../css/InicioPage/PortadaInicio.css"

import logo from'../../Image/nosotros-hod-87.png';




export const PortadaInicioPages = () => {
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [slides, setSliders] = useState([]);
  const dir = React.useRef(0); // para saber si es next (+1) o prev (-1)
  const getFullURL = useCallback((path) => (path ? `${backendURL}/${path}` : ""), [backendURL]);

  const isPrerender = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap"


// Carga de slides desde backend
  const fetchSliders = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${backendURL}/api/all/public/banner`);
      setSliders(response.data.data || []);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    } finally {
      setLoading(false);
    }
  }, [backendURL]);

  // Fetch solo si NO es prerender
  useEffect(() => {
    if (!isPrerender) {
      fetchSliders();
    }
  }, [fetchSliders, isPrerender]);
  
   // Preload imágenes cuando cambian slides
  useEffect(() => {
  slides.forEach((slide) => {
    const img = new Image();
    img.src = getFullURL(slide.imagen_fondo);
  });
}, [slides, getFullURL]);

   useEffect(() => {
    if (isPrerender) return;

    const interval = setInterval(() => {
      setIndex((prevIndex) => {
        dir.current = 1;
        return (prevIndex + 1) % slides.length;
      });
    }, 6000);

    return () => clearInterval(interval);
  }, [slides.length, isPrerender]);

  // Manejar cambio de slide manual
  const handleChange = (newIdx) => {
    dir.current = newIdx > index ? 1 : -1;
    setIndex((newIdx + slides.length) % slides.length);
  };

   if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                    <CircularProgress size={80} thickness={6}  /> {/* Hacemos el CircularProgress más grande */}
                </Box>
            </div>
        );
    }
  
     if (!slides.length) return null;

  const currentSlide = slides[index] || {};
  return (
    <Box
    className="PortadaInicio"
      sx={{
    position: 'relative',
    overflow: 'hidden', // ⬅️ importante para evitar parpadeo de fondo blanco
    height: '100vh',     // ajusta si es necesario
  }}

    >
      {/* Flecha anterior */}
      <IconButton
      className="BotonAnterior"
        onClick={() => handleChange(index - 1)}
        sx={{ position: "absolute", top: "50%", left: 10, zIndex: 10, color: "#fff",  '@media (max-width:500px)': {
        display:'none'
    }, }}
      >
        <ArrowBackIos />
      </IconButton>

      {/* Flecha siguiente */}
      <IconButton
      className="BotonSiguiente"
        onClick={() => handleChange(index + 1)}
        sx={{ position: "absolute", top: "50%", right: 10, zIndex: 10, color: "#fff",  '@media (max-width:500px)': {
        display:'none'
    }, }}
      >
        <ArrowForwardIos />
      </IconButton>

      {/* Slide animado */}
    <Box sx={{ position: "relative", height: "100vh", overflow: "hidden" }}>
       <h1 style={{color:'transparent', position:'absolute'}}> cotizar vending, presupuesto máquinas expendedoras, asesoría vending, cotización automática, soluciones vending, catálogo Jofemar Chile, empresa de vending Chile, historia HOD, vending sostenible, equipo HOD, tecnología vending, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, servicio técnico vending, instalación máquinas vending, mantenimiento vending, soporte postventa, asistencia vending, repuestos Jofemar</h1>
  {slides.map((slide, i) => (
    <motion.div
       key={i}
      animate={{ opacity: i === index ? 1 : 0 }}
      transition={{ duration: 0.8 }}
      style={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url(${getFullURL(slide.imagen_fondo)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        pointerEvents: i === index ? "auto" : "none",
        zIndex: i === index ? 2 : 1,
      }}
    >
         

          {/* Contenido central */}
          <Container
          className="contienetodo"
             sx={{
                display: "flex",
                alignItems: "center",      // centra verticalmente
                justifyContent: "space-between", // uno a la izquierda y otro a la derecha
                height: "100%",            // para usar toda la altura del slide
                zIndex: 2,  
                  '@media (max-width:600px)': { 
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center'
                  }             
              }}
          >
             <Box 
                className="ContieneImagenyTexto"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                   '@media (max-width:600px)': { 
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center'
                  }   // centra verticalmente dentro de este box si es necesario
                }}
              >
            {i === index && (
          <>
            <motion.img
              key={`logo-${i}`}
              src={getFullURL(slide.imagen_logo)}
              className="TituloInicioPortada"
               alt="HOD | Maquinas Dispensadoras"
                 title="HOD | Maquinas Dispensadoras"
              initial={{ x: slide.textPosition === "left" ? -50 : 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              style={{ marginBottom: 16 }}
            />
            <motion.img
              key={`texto-${i}`}
              src={getFullURL(slide.imagen_texto)}
              className="DescripcionInicioPortada"
               alt="HOD | Maquinas Dispensadoras"
               title="HOD | Maquinas Dispensadoras"
              initial={{ x: slide.textPosition === "left" ? -30 : 30, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              style={{ marginBottom: 24 }}
            />
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.9 }}
            />
          </>
        )}
            </Box>
            <Box 
            sx={{
              display:'flex',
              alignItems:'flex-end',
              justifyContent:'center',
              flexDirection:'row',
               '@media (max-width:899px)': {
alignItems:'center',
justifyContent:'center',
flexDirection:'column'
      }
            }}>
               {/* Máquina animada */}
            {i === index && slide.imagen_maquina && (
              <>
           <motion.img
              key={`maquina-${index}`}
            className="ImagenMaquinaPortadaInicio"
            src={currentSlide && currentSlide.imagen_maquina ? getFullURL(currentSlide.imagen_maquina) : ''}
            initial={{ x: 300, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
             alt="HOD | Maquinas Dispensadoras"
              title="HOD | Maquinas Dispensadoras"
             

          /> 
           <Box
           key={`logo-${index}`} 
  sx={{
    width: '200px',
    position: 'relative',
    bottom: '90px',
    right:'10%',
     '@media (max-width:700px)': {

width:'50%',
 bottom: '60px',
  right:'0%',
      }
  }}
>
  <motion.img
    src={logo}
     
    width="100%"
    alt="Logo HOD"
    title="Logo HOD"
    initial={{ x: 300, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
  />
</Box>
           
          </>
            )}
            
           
            </Box> 
          </Container>

        </motion.div>
        ))}
      </Box>

      

      {/* Bullets de paginación */}
      <Box
        sx={{
          position: "absolute",
          bottom: 16,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: 1,
        }}
      >
        {slides.map((_, i) => (
          <Box
            key={i}
            onClick={() => handleChange(i)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: "1px solid rgba(133, 133, 133, 0.81)",
              bgcolor: i === index ? "#fff" : "rgba(222, 220, 220, 0.5)",
              cursor: "pointer",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};